import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { PrefsMenu } from './PrefsMenu';
import { ButtonLink } from '../ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
import { spring, staggerContainer } from '../../utils/motion';
import { cn } from '../../utils/cn';
export function PublicHeader() {
  const {
    t
  } = useLocale();
  const {
    isSignedIn,
    home
  } = useSession();
  const [open, setOpen] = useState(false);
  const reduce = useReducedMotion();
  const links = [{
    to: '/discover',
    label: t('nav.discover')
  }, {
    to: '/how-it-works',
    label: t('nav.how')
  }, {
    to: '/for-chefs',
    label: t('nav.forChefs')
  }, {
    to: '/contact',
    label: t('nav.contact')
  }];
  return <header className="sticky top-0 z-40 border-b border-hairline bg-canvas/90 backdrop-blur-md" data-id="element-870" data-mp="fs9mv54w4jer">
      <div className="mx-auto flex h-16 max-w-shell items-center gap-6 px-5 lg:px-8" data-id="element-871" data-mp="2hvv6lo9mnwlh">
        <Logo data-id="element-872" data-mp="2cy3bymhllwdl" />
        <nav aria-label="Main" className="hidden flex-1 items-center gap-1 md:flex" data-id="element-873" data-mp="2d0pkopg86hxe">
          {links.map(link => <NavLink key={link.to} to={link.to} className={({
          isActive
        }) => cn('rounded-full px-3.5 py-2 text-sm font-medium transition-colors duration-150 ease-out', isActive ? 'bg-oat text-ink' : 'text-ink-2 hover:bg-oat hover:text-ink')} data-id="element-874" data-mp="2lz9vl4fjnnb2">
              {link.label}
            </NavLink>)}
        </nav>
        <div className="ml-auto flex items-center gap-2 md:ml-0" data-id="element-875" data-mp="2378r9mk034u9">
          <PrefsMenu compact data-id="element-876" data-mp="1fifqncsfo8tb" />
          {isSignedIn ? <ButtonLink to={home} variant="primary" size="sm" className="hidden sm:inline-flex" data-id="element-877" data-mp="1fguvpm27inux">
              {t('nav.enter')}
            </ButtonLink> : <>
              <Link to="/onboarding" className="hidden rounded-full px-3 py-2 text-sm font-medium text-ink-2 transition-colors duration-150 ease-out hover:text-ink sm:inline-flex" data-id="element-878" data-mp="3am42r7nla3qz">
                {t('nav.signIn')}
              </Link>
              <ButtonLink to="/discover" variant="action" size="sm" className="hidden sm:inline-flex" data-id="element-879" data-mp="3paqqnxra83tt">
                {t('home.searchCta')}
              </ButtonLink>
            </>}
          <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-lg border border-hairline p-2 text-ink-2 md:hidden" data-id="element-880" data-mp="2wne3bldarrzg">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-881" data-mp="guf5bxw835t8" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-882" data-mp="gxt5czhez2xi" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-883" data-mp="25f32f26mc02s">
        {open && <motion.div initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: -8
      }} animate={reduce ? {
        opacity: 1
      } : {
        opacity: 1,
        y: 0
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: -6
      }} transition={reduce ? {
        duration: 0.14
      } : spring.smooth} className="border-t border-hairline bg-canvas md:hidden" data-id="element-884" data-mp="25dt1m58dsdsg">
            <motion.nav aria-label="Main" variants={staggerContainer(0.05, 0.02)} initial="hidden" animate="show" className="mx-auto flex max-w-shell flex-col gap-1 px-5 py-4" data-id="element-885" data-mp="1mov550plo3ui">
              {links.map(link => <motion.div key={link.to} variants={{
            hidden: {
              opacity: 0,
              y: reduce ? 0 : 8
            },
            show: {
              opacity: 1,
              y: 0
            }
          }} data-id="element-886" data-mp="18plojzxhf7q0">
                  <Link to={link.to} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-3 font-display text-lg text-ink hover:bg-oat" data-id="element-887" data-mp="381fqv62yaamo">
                    {link.label}
                  </Link>
                </motion.div>)}
              <ButtonLink to={isSignedIn ? home : '/discover'} variant="action" size="md" full className="mt-2" data-id="element-888" data-mp="24oo38gzxloyg">
                {isSignedIn ? t('nav.enter') : t('home.searchCta')}
              </ButtonLink>
            </motion.nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}